export default {"src":"/_next/static/media/Favicon.e2f430d6.svg","height":311,"width":311,"blurWidth":0,"blurHeight":0};